import { gql } from "@apollo/client"
import { TRAINING_MODULE_STEP_FIELDS } from "./moduleStepFragment"
import { TRAINING_COURSE_AUTO_ASSIGNMENT_FIELDS } from "./autoAssignmentFragments"

export const TRAINING_COURSE_FIELDS = gql`
  fragment TrainingCourseFields on TrainingCourse {
    id
    name
    description
    banner {
      id
      key
      fileName
      fileGroup
      fileSize
    }
    inactive
    allowHints
    estimatedCompletionTimeMinutes
    numberOfModules
    allowRetry
    showUserAnswers
    showUserScore
    modules {
      module {
        id
      }
      hiddenSteps
      optional
    }
  }
`

export const TRAINING_COURSES_FIELDS = gql`
  fragment TrainingCoursesFields on TrainingCourse {
    id
    name
    description
    banner {
      id
      key
      fileName
      fileGroup
      fileSize
    }
    inactive
    estimatedCompletionTimeMinutes
    numberOfModules
    minimumPassPercent
    showUserScore
  }
`

export const TRAINING_COURSE_DETAIL_FIELDS = gql`
  fragment TrainingCourseDetailFields on TrainingCourse {
    id
    name
    description
    author {
      id
      firstName
      lastName
      avatar {
        key
      }
    }
    lastUpdatedBy {
      id
      firstName
      lastName
      avatar {
        key
      }
    }
    inactive
    banner {
      id
      key
      fileName
      fileGroup
      fileSize
    }
    minimumPassPercent
    estimatedCompletionTimeMinutes
    dueDays
    tags {
      id
      name
    }
    modules {
      module {
        id
        name
        description
        createdAt
        updatedAt
        steps {
          ...TrainingModuleStepFields
        }
        banner {
          id
          key
        }
        type
      }
      hiddenSteps
      overrideMandatorySteps
      optional
    }
    autoAssignment {
      ...TrainingCourseAutoAssignmentFragment
    }
    allowHints
    allowRetry
    showUserScore
    showUserAnswers
    createdAt
    updatedAt
  }
  ${TRAINING_MODULE_STEP_FIELDS}
  ${TRAINING_COURSE_AUTO_ASSIGNMENT_FIELDS}
`
